import {
    EmptyDarkIcon,
    EmptyIcon,
    StereoAIStudioIcon,
    StereoAppDarkIcon,
    StereoAppLightIcon,
    StereoBackDarkIcon,
    StereoBackLightIcon,
    StereoCdkDarkIcon,
    StereoCdkLightIcon,
    StereoFrontDarkIcon,
    StereoFrontLightIcon,
    StereoSolutionDarkIcon,
    StereoSolutionLightIcon,
} from '@codes/assets';
import { useTheme } from '@codes/theme';

const stereoIcons = {
    light: {
        back: StereoBackLightIcon,
        cdk: StereoCdkLightIcon,
        front: StereoFrontLightIcon,
        solution: StereoSolutionLightIcon,
        app: StereoAppLightIcon,
        aistudio: StereoAIStudioIcon,
        default: EmptyIcon,
    },
    system: {
        back: StereoBackLightIcon,
        cdk: StereoCdkLightIcon,
        front: StereoFrontLightIcon,
        solution: StereoSolutionLightIcon,
        app: StereoAppLightIcon,
        aistudio: StereoAIStudioIcon,
        default: EmptyIcon,
    },
    dark: {
        back: StereoBackDarkIcon,
        cdk: StereoCdkDarkIcon,
        front: StereoFrontDarkIcon,
        solution: StereoSolutionDarkIcon,
        app: StereoAppDarkIcon,
        aistudio: StereoAIStudioIcon,
        default: EmptyDarkIcon,
    },
} as const;

type StereoType = keyof typeof stereoIcons.light;

const getIconByStereo = (stereo: string, theme: 'dark' | 'light' | 'system') => {
    const iconSet = stereoIcons[theme];
    return iconSet[stereo as StereoType] || iconSet.default;
};

export const useStereoIcon = () => {
    const { theme } = useTheme();

    return (stereo: string) => {
        return getIconByStereo(stereo, theme);
    };
};
